<ch-loader [loading]="loading"></ch-loader>
<div [ngStyle]="{ display: loading ? 'none' : 'block' }">
  <form (ngSubmit)="submitForm(form)" #form="ngForm">
    <div class="container-fluid">
      <div class="row">
        <div class="container">
          <div class="card mb-4">
            <div class="card-header">Sponsor</div>
            <div class="card-body">
              <div class="form-group">
                <label for="name">Name</label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="sponsor.name"
                  name="sponsorName"
                  #sponsorName="ngModel"
                  class="form-control"
                  id="name"
                  required
                  [readonly]="loading"
                />
                <small class="text-danger" *ngIf="(sponsorName.touched || sponsorName.dirty) && !sponsorName.valid">
                  Name is not valid
                </small>
              </div>

              <div class="form-group">
                <label for="logo-id">Logo</label>
                <ch-image-upload id="logo-id" (onChange)="updateLogo($event)" [resourceId]="sponsor.logoId"></ch-image-upload>
              </div>

              <div style="margin-top: 40px;">
                <button id='sponsorsEditDelete' *ngIf="id" type="button" class="btn btn-danger" (click)="delete()" [disabled]="loading">Delete</button>
                <span class="btn-right">
                  <button id='sponsorsEditCancel' type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="loading">Cancel</button>
                  <button id='sponsorsEditSave' type="submit" class="btn btn-primary" [disabled]="loading">Save</button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/sponsors/sponsors-edit/sponsors-edit.component.html